//Libs
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
//Componentes Material
import Grid from '@material-ui/core/Grid';
//Ícones
import PersonIcon from '@material-ui/icons/Person';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
//Relatórios
import RelatorioClientes from './relatorio/RelatorioClientes';
import RelatorioAvaliacoes from './relatorio/RelatorioAvaliacoes';

/**
 * Componente para exiber os relatórios e atalhos para o perfil Empresa
 */
class DashboardEmpresa extends Component {
    render() {
        return (
            <Fragment>
                <Grid container spacing={1} >
                    <Grid item xs={12} sm={4} >
                        <Button startIcon={<PersonIcon />} size="large" variant="contained" color="primary" component={Link} to="/cliente/add" style={{ width: '100%' }} >Adicionar formando</Button>
                    </Grid>
                    <Grid item xs={12} sm={4} >
                        <Button startIcon={<AssignmentIndIcon />} size="large" variant="contained" color="primary" component={Link} to="/avaliador/add" style={{ width: '100%' }} >Adicionar avaliador</Button>
                    </Grid>
                    <Grid item xs={12} sm={4} >
                        <Button startIcon={<PlaylistAddCheckIcon />} size="large" variant="contained" color="primary" component={Link} to="/avaliacao/add" style={{ width: '100%' }} >Iniciar avaliacao</Button>
                    </Grid>
                </Grid>
                <Grid container spacing={1} >
                    <RelatorioClientes />
                    <RelatorioAvaliacoes />
                </Grid>
            </Fragment>
        );
    }
}

export default DashboardEmpresa;